import React from 'react';
import * as RadixSwitch from '@radix-ui/react-switch';
import { cn } from '@/lib/utils';

interface SwitchProps {
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  /** Accessible name when there's no visible label tied to it. */
  label?: string;
  className?: string;
}

/** On/off toggle (Figma "Switch"). */
const Switch: React.FC<SwitchProps> = ({ checked, onCheckedChange, disabled, label, className }) => (
  <RadixSwitch.Root
    checked={checked}
    onCheckedChange={onCheckedChange}
    disabled={disabled}
    aria-label={label}
    className={cn(
      'tw-relative tw-inline-flex tw-h-6 tw-w-11 tw-shrink-0 tw-items-center tw-rounded-full tw-transition-colors',
      'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ds-brand focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-ds-surface',
      'data-[state=checked]:tw-bg-ds-brand data-[state=unchecked]:tw-bg-ds-border-strong disabled:tw-cursor-not-allowed disabled:tw-opacity-50',
      className,
    )}
  >
    <RadixSwitch.Thumb className="tw-block tw-h-5 tw-w-5 tw-translate-x-0.5 tw-rounded-full tw-bg-white tw-shadow-sm tw-transition-transform data-[state=checked]:tw-translate-x-[22px]" />
  </RadixSwitch.Root>
);

export default Switch;
